import { Component, Input, Output, OnInit } from 'angular-ts-decorators';
import { SwChange } from '@core/app/scripts/classes/sw-change';
import { Currencies, ICurrency } from '../../services/currencies';

/**
 * Component to display all world currencies, and allow user
 * user to choose one.
 *
 * # Attributes:
 * * sw-change - callback function, is called with the new value provided in `value`
 * * sw-model - accept the value to be set, one way binding
 * * sw-readonly - if the field is editable
 *
 * ## Usage
 * <pre>
 *   <sw-currency-picker sw-model="valueSource" sw-readonly="[true|false]" sw-change="callback(value)"></sw-currency-picker>
 * </pre>
 */
@Component({
  selector: 'swCurrencyPicker',
  template: require('./sw-currency-picker.html').default,
})
export class SwCurrencyPickerComponent extends SwChange implements OnInit {
  @Input() swModel;
  @Input() swReadonly;
  @Output() swChange: () => any;

  currenciesList: ICurrency[];

  constructor(private currencies: Currencies) {
    'ngInject';

    super();
  }

  ngOnInit() {
    this.currenciesList = this.currencies.list;
  }
}
